<h1>Walkpath Order</h1>
<p>Unlock to edit the Walkpath. Click and drag Departments to change their order.</p>
<div class="button-container">
  <button class="pointer lock-button-icon" [hidden]="!walkpathLocked" (click)="lockButtonEvent()">
    <img src="/assets/images/Lock.svg" />
  </button>
  <button class="pointer lock-button-icon" [hidden]="walkpathLocked" (click)="lockButtonEvent()">
    <img src="/assets/images/Unlock.svg" />
  </button>
</div>
<div cdkDropList class="walkpath-list" (cdkDropListDropped)="drop($event)" [cdkDropListDisabled]="walkpathLocked">
  @for (prepLocation of facilityPrepLocations; track prepLocation) {
    <div class="example-box" cdkDrag>
      {{ prepLocation.prepLocationTypeName }}
    </div>
  }
</div>
